import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class LaudosPdfService extends Service{

  protected url: string = this.dominio+"/adm/fichas/laudos-pdf/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  // envia a ficha para o cliente por email
  enviarLaudoParaCliente(id){
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id +'/notificar', {},{headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  enviarLaudoParaEmailEspecifico(id, email) {
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id + '/notificar-com-email', JSON.stringify({ email }), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  setStatus(id_laudo, id_status, notificar: boolean = true){

    let headers = this.getHeaderLogado();
    let url = this.dominio+"/adm/fichas/laudos-pdf/"+id_laudo+"/status/"+id_status+"/";

    if (!notificar) {
      url += "nao-notifica";
    }

    return this.http
      .put(url, {}, { headers })
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  existePDF(id_laudo){
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id_laudo + '/existe-pdf', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  setValor(id_laudo, valor){

    let headers = this.getHeaderLogado();

    return this.http
      .put(
        this.url + id_laudo+"/alterar-valor/", JSON.stringify({"valor": valor}),
        { headers }
      )
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  faturarLaudo(id_laudo, data){

    let headers = this.getHeaderLogado();

    return this.http
      .put(
        this.dominio+"/adm/faturas/faturar-laudo/"+id_laudo, JSON.stringify({"data": data}),
        { headers }
      )
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }



}



// WEBPACK FOOTER //
// ./src/app/laudos-pdf/laudos-pdf.service.ts